var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModerateRainV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 54H34.5H36H55.5C64.6127 54 72 46.6127 72 37.5C72 28.3873 64.6127 21 55.5 21C55.1382 21 54.7791 21.0116 54.4231 21.0346C50.6566 13.879 43.1481 9 34.5 9C23.6003 9 14.5107 16.7504 12.4418 27.0409C5.48057 27.5806 0 33.4003 0 40.5C0 47.9558 6.04416 54 13.5 54Z",
    fill: "#E7F1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 54H34.5H36H55.5C64.6127 54 72 46.6127 72 37.5C72 28.3873 64.6127 21 55.5 21C55.1382 21 54.7791 21.0116 54.4231 21.0346C50.6566 13.879 43.1481 9 34.5 9C23.6003 9 14.5107 16.7504 12.4418 27.0409C5.48057 27.5806 0 33.4003 0 40.5C0 47.9558 6.04416 54 13.5 54Z",
    fill: "url(#paint0_linear_537_36557)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 54H34.5H36H55.5C64.6127 54 72 46.6127 72 37.5C72 28.3873 64.6127 21 55.5 21C55.1382 21 54.7791 21.0116 54.4231 21.0346C50.6566 13.879 43.1481 9 34.5 9C23.6003 9 14.5107 16.7504 12.4418 27.0409C5.48057 27.5806 0 33.4003 0 40.5C0 47.9558 6.04416 54 13.5 54Z",
    fill: "url(#paint1_linear_537_36557)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 40.5C0 33.0442 6.04416 27 13.5 27H18C27.9411 27 36 35.0589 36 45V54H13.5C6.04416 54 0 47.9558 0 40.5Z",
    fill: "url(#paint2_radial_537_36557)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 31.5C12 19.0736 22.0736 9 34.5 9C46.9264 9 57 19.0736 57 31.5C57 43.9264 46.9264 54 34.5 54C22.0736 54 12 43.9264 12 31.5Z",
    fill: "url(#paint3_radial_537_36557)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 37.5,
    r: 16.5,
    fill: "url(#paint4_radial_537_36557)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 61.5002V41.1006C45 39.2254 47.2709 38.2904 48.5912 39.6219L62.8413 53.9931C64.7903 55.8994 66 58.5585 66 61.5002C66 67.2992 61.299 72.0002 55.5 72.0002C49.701 72.0002 45 67.2992 45 61.5002Z",
    fill: "#C4C4C4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 61.5002V41.1006C45 39.2254 47.2709 38.2904 48.5912 39.6219L62.8413 53.9931C64.7903 55.8994 66 58.5585 66 61.5002C66 67.2992 61.299 72.0002 55.5 72.0002C49.701 72.0002 45 67.2992 45 61.5002Z",
    fill: "url(#paint5_linear_537_36557)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 59.4411V43.3308C18 41.4556 20.2709 40.5206 21.5912 41.8522L32.5983 52.9529C34.6711 54.6017 36 57.1458 36 60.0002C36 64.9708 31.9706 69.0002 27 69.0002C22.0294 69.0002 18 64.9708 18 60.0002C18 59.81 18.0059 59.6212 18.0175 59.4339L18 59.4411Z",
    fill: "#C4C4C4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 59.4411V43.3308C18 41.4556 20.2709 40.5206 21.5912 41.8522L32.5983 52.9529C34.6711 54.6017 36 57.1458 36 60.0002C36 64.9708 31.9706 69.0002 27 69.0002C22.0294 69.0002 18 64.9708 18 60.0002C18 59.81 18.0059 59.6212 18.0175 59.4339L18 59.4411Z",
    fill: "url(#paint6_linear_537_36557)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 37.4998V24.4358C27 22.5606 29.2709 21.6256 30.5912 22.9571L39.282 31.7218C40.9423 33.0975 42 35.1751 42 37.4998C42 41.642 38.6421 44.9998 34.5 44.9998C30.4968 44.9998 27.2262 41.8635 27.0112 37.9139L27 37.9186V37.4998Z",
    fill: "#C4C4C4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 37.4998V24.4358C27 22.5606 29.2709 21.6256 30.5912 22.9571L39.282 31.7218C40.9423 33.0975 42 35.1751 42 37.4998C42 41.642 38.6421 44.9998 34.5 44.9998C30.4968 44.9998 27.2262 41.8635 27.0112 37.9139L27 37.9186V37.4998Z",
    fill: "url(#paint7_linear_537_36557)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_537_36557",
    x1: 22.5,
    y1: 19.5,
    x2: 36,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89AFD1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_537_36557",
    x1: 32.0998,
    y1: 55.5925,
    x2: 31.1538,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#547DDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257422,
    stopColor: "#93C2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_537_36557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5 54) rotate(-127.875) scale(28.5044 32.9871)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.683784,
    stopColor: "#8FABDD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5582D3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_537_36557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.5 49.5) rotate(-90) scale(40.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.598765,
    stopColor: "#C7DFFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B97E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_537_36557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.7 49.6) rotate(-56.3099) scale(31.7288)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47771,
    stopColor: "#8FABDD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5582D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_537_36557",
    x1: 60.7509,
    y1: 69.8232,
    x2: 41.7826,
    y2: 48.9185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65ACFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_537_36557",
    x1: 31.5008,
    y1: 67.1682,
    x2: 15.5695,
    y2: 49.2848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65ACFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_537_36557",
    x1: 38.2506,
    y1: 43.5046,
    x2: 25.2817,
    y2: 28.6405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65ACFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModerateRainV2);
export default __webpack_public_path__ + "static/media/ModerateRainV2.32d7fbcdd6a3d81f1862153bc9225a43.svg";
export { ForwardRef as ReactComponent };